import { Popover } from 'antd'
import styles from './SubAnalysisDescriptionPopover.module.less'
import AIcon from '@/components/A/AIcon/AIcon'
import { memo, useMemo } from 'react'

function SubAnalysisDescriptionPopover(props: {
  descriptions: { title: string; description: string }[]
}) {
  const content = useMemo(() => (
    <div className={styles.popoverContent}>
      {props.descriptions.map((item, index) => (
        <div className={styles.descriptionItem} key={index}>
          <span className={styles.title}>{item.title}：</span>
          <span className={styles.description}>{item.description}</span>
        </div>
      ))}
    </div>
  ), [props.descriptions])

  return (
    <Popover
      placement='rightTop'
      destroyTooltipOnHide
      content={content}
    >
      <span>
        <AIcon width={18} type='icon-line-global_question' />
      </span>
    </Popover>
  )
}

export default memo(SubAnalysisDescriptionPopover, (prevProps, nextProps) => {
  if (prevProps.descriptions.length !== nextProps.descriptions.length) {
    return false
  }
  return prevProps.descriptions.every((item, index) => {
    const nextItem = nextProps.descriptions[index]
    return item.title === nextItem.title && item.description === nextItem.description
  })
})
